import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { AdditionalMaterials } from './additionalMaterials';
import { ContentEditor } from './contentEditor';
import { Cover } from './cover';
import { Dripping } from './dripping';
import { Media } from './media';
import { Name } from './name';
import { Tags } from './tags';
export default function ContentForm() {
    const [mediaThumbnail, setMediaThumbnail] = useState(null);
    return (_jsxs("div", { className: "my-5 flex flex-col-reverse justify-center px-4 md:px-5 lg:my-7 lg:flex-row lg:gap-7", children: [_jsxs("div", { className: "pb-10 lg:w-[646px]", children: [_jsx(Name, {}), _jsx(Media, { onSetThumbnail: setMediaThumbnail }), _jsx(ContentEditor, {}), _jsx(AdditionalMaterials, {}), _jsx(Dripping, {}), _jsx(Tags, {})] }), _jsx("div", { className: "mb-7 h-[fit-content] lg:sticky lg:top-7", children: _jsx(Cover, { mediaThumbnail: mediaThumbnail }) })] }));
}
